import { useLocation } from "react-router-dom";

export type LanguageCode = "de" | "en";

const normalizePath = (path: string) => (path.endsWith("/") && path.length > 1 ? path.slice(0, -1) : path);

export default function useLanguage() {
  const location = useLocation();
  const path = normalizePath(location.pathname || "/");
  const isEnglish = path === "/en" || path.startsWith("/en/");
  const lang: LanguageCode = isEnglish ? "en" : "de";
  const prefix = isEnglish ? "/en" : "";

  const withLang = (href: string) => {
    if (!href) return href;
    if (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("mailto:")) return href;
    if (!href.startsWith("/")) return href;
    if (href.startsWith("/en/") || href === "/en") return href;
    return `${prefix}${href}` || href;
  };

  return { lang, prefix, withLang };
}
